import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StatisticsState } from './statistics.reducers';

export const statisticsState = createFeatureSelector<StatisticsState>('statistics');

export const statisticsSelector = createSelector(statisticsState, statistics => statistics.statistics);
